<template>
  <DeleteConfirmationModal
    v-if="isModalOpen"
    v-model="isModalOpen"
    :resource-name="record.title"
    @delete="deleteRecord"
  >
    <template #header>
      <h1 class="modal__title">
        {{ $t('delete.record.confirmation.header') }}
      </h1>
    </template>
    <template #consequences-description>
      <i18n-t
        v-if="profile.roles.includes('operator') || isUnitManager()"
        keypath="delete.record.confirmation.operator.text"
        tag="p"
      >
        <span
          place="redText"
          class="u-text-danger"
        >{{ $t('delete.record.confirmation.operator.redText') }}</span>
      </i18n-t>
      <p v-else>
        {{ $t('delete.record.confirmation.author.text') }}
      </p>
      <div class="card">
        <Record
          :record="record"
          :clickable="false"
        />
      </div>
    </template>
    <template #delete-button-text>
      {{ $t('delete.record.confirmation.button') }}
    </template>
  </DeleteConfirmationModal>
</template>
<script>
import DeleteConfirmationModal from '#src/components/DeleteConfirmationModal.vue'
import Record from '#src/components/records/Record.vue'
import useRecordsAPI from '#src/api/records'
import { isUnitManagerOfAuthorMemberships } from '#src/utils/record-helpers'

import { mapState } from 'vuex'

export default {
  components: {
    DeleteConfirmationModal,
    Record
  },
  inject: ['$axios'],
  props: {
    modelValue: {
      type: Boolean,
      required: true
    },
    record: {
      type: Object,
      required: true
    }
  },
  emits: ['deleted', 'input', 'update:modelValue'],
  data() {
    return {
      RecordsAPI: useRecordsAPI(this.$axios)
    }
  },
  computed: {
    isModalOpen: {
      get() {
        return this.modelValue
      },
      set(val) {
        this.$emit('input', val)
        this.$emit('update:modelValue', val)
      }
    },
    ...mapState({
      profile: state => state.profile
    })
  },
  methods: {
    async deleteRecord() {
      await this.RecordsAPI.remove({ id: this.record.metadata.id })
      this.$emit('deleted', this.record.metadata.id)
      this.isModalOpen = false
    },
    isUnitManager() {
      return isUnitManagerOfAuthorMemberships({ record: this.record, profile: this.profile })
    }
  }
}
</script>
